<template>
  <span class="tabular-nums">
    {{ formatted }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
  value: number | undefined;
}>();

const formatter = new Intl.NumberFormat(undefined, {
  style: "percent",
});

const formatted = computed(() => {
  const value = props.value;
  if (value === undefined || Number.isNaN(value)) {
    return `—`;
  }

  return formatter.format(value);
});
</script>
